import { Box } from '@mui/material';
import { FC } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';

import ButtonsList from '@components/Capture/components/ButtonsList';
import { ButtonConfig } from '@components/Capture/types';
import { ImagePreview } from '@uiKit/ImagePreview';

import { sxCanvasHeight, sxMobileGroupBtn } from './styles';

type Props = {
  image: string;
  isMobile: boolean;
  buttons: ButtonConfig[];
};

const ImagePreviewContainer: FC<Props> = ({ image, isMobile, buttons }) => (
  <Box sx={sxCanvasHeight(isMobile)}>
    <AutoSizer>{({ height, width }) => <ImagePreview imageDataUrl={image} width={width} height={height} />}</AutoSizer>
    {isMobile && (
      <Box display="flex" position="fixed" sx={sxMobileGroupBtn}>
        <ButtonsList buttons={buttons} />
      </Box>
    )}
  </Box>
);

export default ImagePreviewContainer;
